import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import MarkdownHelp from "./MarkdownHelp.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownHelpModal',
    props: {
        mode: null
    },
    setup(__props, { expose }) {
        const props = __props;
        const show = ref(false);
        const title = computed(() => {
            if (props.mode == "page") {
                return "Markdown Help for Pages";
            }
            else {
                return "Markdown Help for Invocation Reports";
            }
        });
        function showMarkdownHelp() {
            show.value = true;
        }
        expose({
            showMarkdownHelp,
        });
        return { __sfc: true, props, show, title, showMarkdownHelp, MarkdownHelp };
    }
});
